module.exports = __webpack_public_path__ + "static/media/CloseIconAct.96a352db.svg";